// https://github.com/angular/angular.js/blob/master/src/ng/directive/input.js#L14
const EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

export function EmailListValidator() {
	return {
		require: 'ngModel',
		link: function (scope, elm, attrs, ctrl) {
			ctrl.$validators.emaillist = function (modelValue, viewValue) {

				if (ctrl.$isEmpty(modelValue)) {
					// consider empty models to be invalid
					return false;
				}

				var emails = modelValue.split(',');
				for (var i = 0, ii = emails.length; i < ii; i++) {
					var email = emails[i].trim();
					if (!EMAIL_REGEXP.test(email)) {
						return false;
					}
				}

				// is valid
				return true;
			};
		}
	};
}


// WEBPACK FOOTER //
// ./src/phoenix/validators/emailList.ts